<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitlec"><a id="page_xi"><b>Paved Roads and Public Money</b></a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_halftitle01.vue?246d57c6